import React from 'react';
import { Text } from '@primer/react';

interface HighlightedTextProps {
    text: string;
    highlight: string;
}

const HighlightedText: React.FC<HighlightedTextProps> = ({ text, highlight }) => {
    if (!highlight) {
        return <Text as="span" weight="normal" className="text-[14px] text-aloix-grey mt-1 break-words">{text}</Text>;
    }

    const parts = text.split(new RegExp(`(${highlight})`, 'gi'));

    return (
        <Text as="span" weight="normal" className="text-[14px] text-aloix-grey mt-1 break-words">
            {parts.map((part, index) =>
                part.toLowerCase() === highlight.toLowerCase() ? (
                    <span key={index} style={{ backgroundColor: '#0969DA', color: 'white' }}>
                        {part}
                    </span>
                ) : (
                    part
                )
            )}
        </Text>
    );
};

export default HighlightedText;
